/* -----------------Child components--------------- */
import { CustomAppBar } from "@memorang/ui/components/CustomAppbar";

import { pageViewTypes } from "@constants/tracking";
import { useAuthContext } from "@features/auth/contexts/AuthContext";
import ProfileContainer from "@features/dashboard/screens/ProfileContainer";
import { handleNavigateBack } from "@helpers/common";
/* -----------------Types--------------- */
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";

const ProfileRoute = () => {
	const { username } = useAuthContext();

	useAnalytics({
		type: pageViewTypes.profile,
	});

	return (
		<>
			<CustomAppBar
				title={username ?? ""}
				onPressBack={() => handleNavigateBack("/(protected)/(tabs)/home")}
				hideCommandBar
			/>
			<DocumentTitle title="Profile" />
			<ProfileContainer />
		</>
	);
};

export default ProfileRoute;
